<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M42 26L13.66 26L20.83 33.17L18 36L6 24L18 12L20.83 14.83L13.66 22L42 22L42 26Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
